import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingOverlay = ({ loading, children, customClass }) => {
  return (
    <div style={{ position: 'relative' }} className={customClass}>
      <Backdrop
        sx={{
          color: '#FFFFFF',
          zIndex: theme => theme.zIndex.drawer + 1,
          position: 'absolute',
        }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {children}
    </div>
  );
};

export default LoadingOverlay;
